import FinancialSummaryTab from "./components/FinancialSummaryTab/FinancialSummaryTab";
import ExpenseBreakdownTab from "./components/ExpenseBreakdownTab/ExpenseBreakdownTab";
import VehicleProfitabilityTab from "./components/VehicleProfitabilityTab/VehicleProfitabilityTab";
import ReceivablesTab from "./components/ReceivablesTab/ReceivablesTab";
import { FinancialTab } from "./types";

export const FINANCIAL_TABS: FinancialTab[] = [
  { value: "ukupno", label: "Ukupno", content: <FinancialSummaryTab /> },
  { value: "rashodi", label: "Rashodi", content: <ExpenseBreakdownTab /> },
  { value: "vozila", label: "Po vozilu", content: <VehicleProfitabilityTab /> },
  { value: "naplata", label: "Naplata", content: <ReceivablesTab /> },
];

export const FINANCIAL_TAB_VALUES = FINANCIAL_TABS.map((tab) => tab.value);

export const DEFAULT_FINANCIAL_TAB = "ukupno";
